import React from 'react';
import { Button, Spinner } from 'reactstrap'

export default function SpinnerButton(props) {
  return (
    <Button
      type={props.type || "button"}
      disabled={props.disabled}
      className={props.className}
      color={props.color}
      style={props.style}
      onClick={props.onClick}
      size={props.size}
      title={props.title}
    >
      {props.on
        ? <Spinner size="sm" color={props.spinnerColor || "dark"} />
        : props.children}
    </Button>
  )
}